import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
	selector: 'event-list-item-header-not-editable',
	templateUrl: "./item-header.presentation.html",
	styles: [require("./item-header.presentation.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventListItemHeaderNotEditable {

	@Input() visualTickets: boolean
	@Input() visualBulkTickets: boolean
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart-event-list/not-editable/item-header.presentation.ts